export enum GAME_TRANSACTION_STATUS {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMMITTED = 'committed',
  ROLLED_BACK = 'rolled_back',
  FAILED = 'failed',
  ERROR = 'error',
}

export enum CLAN_MANAGEMENT_STATUSES {
  ERROR = 'error',
  OK = 'ok',
  PROCESSING = 'processing',
  TIMEOUT = 'timeout',
}

export enum CLAN_RENAMING_STATUSES {
  ACTIVE = 'active',
  OK = 'ok',
}

export enum CLAN_CREATION_STATUSES {
  ACTIVE = 'active',
  CREATING = 'creating',
  ERROR = 'error',
  OK = 'ok',
  PAYMENT_REJECTED = 'payment_rejected',
  PAYMENT_REQUESTED = 'payment_requested',
  REDIRECT = 'redirect',
}
